import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledInfoContainer = styled.div<{
  $variant: string;
}>`
  border-radius: 8px;
  padding: 15px 20px;
  background-color: ${({ $variant: variant }) =>
    variant === "1" ? theme.colors.purple_2 : theme.colors.white};
  border: 1px solid
    ${({ $variant: variant }) =>
      variant === "1" ? theme.colors.white : theme.colors.purple_2};
`;
